import { useState } from "react"

const useCurrentBreakPoint = (): [boolean, VoidFunction, VoidFunction] => {
  const [isOpen, setIsOpen] = useState(false)

  const open = () => setIsOpen(true)
  const close = () => setIsOpen(false)

  return [isOpen, open, close]
}

export default useCurrentBreakPoint
